import React from 'react';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import $ from 'jquery';
import {
  FormControl,
  Button,
} from '../../form/FormControls.jsx';
import RequiredFormControl from '../../form/RequiredFormControl.jsx';
import { refUpdate, refCreate } from './simple.store';
import { MainComponentBox, FormGroupWValidation as FormGroup,
  createFormData, goBack, locationFallThrough } from '../../../util/util.jsx';
import 'react-widgets/lib/less/react-widgets.less';
import { getSimpleListWrapper } from './SimpleWrapper.js';
import EditWarningRow from '@/component/dict/simple/EditWarningRow';

export const mapDispatchToProps = (refName, refPath) => (dispatch, props) => ({
  updateRef(ref) {
    refUpdate(dispatch, ref, `${refName}`, `${refPath}`);
  },
  createRef(refDto) {
    refCreate(dispatch, refDto, `${refName}`, `${refPath}`);
  },
  cancel() {
    goBack(props.location.pathname);
  },
});

export class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.state = {};
  }
  componentWillMount() {
    getSimpleListWrapper(this.refName, this.refPath);
    locationFallThrough(`${(this.props.refObject && this.props.refObject.get('name')) || ''}`,
      `/references/${this.refPath}/${(this.props.refObject
      && this.props.refObject.get('id', 'new')) || 'new'}`);
    if (this.props.refObject) {
      this.setState({ ref: this.props.refObject });
    }
  }

  componentDidMount() {
    $('input[name=name]').ready(() => $('input[name=name]').focus());
  }

  componentWillReceiveProps(props) {
    getSimpleListWrapper(this.refName, this.refPath);
    locationFallThrough(`${(props.refObject && props.refObject.get('name')) || ''}`,
      `/references/${this.refPath}/${(props.refObject
      && props.refObject.get('id', 'new')) || 'new'}`);
    if (props.refObject) {
      this.setState({ ref: props.refObject });
    }
  }
  onSubmit(event) {
    event.preventDefault();
    $('input').prop('disabled', false);
    const formData = (createFormData('refForm'));
    formData.id = formData.id === '' ? undefined : formData.id;
    formData.predefine = formData.predefine === '' ? undefined : formData.predefine;
    formData.searchText = formData.searchText === '' ? undefined : formData.searchText;
    $("input[data-predefined='true']").prop('disabled', true);
    if (this.props.params.refId == 'new') {
      this.props.createRef(formData);
    } else {
      this.props.updateRef(formData);
    }
  }

  onCancel() {
    this.props.cancel();
  }

  getLabel = () => {
    if (this.props.params.refId === 'new') {
      return <div className={'edit-reference-header'}>{`New ${this.name}`}</div>;
    }
    return <div className={'edit-reference-header'}>{`Edit ${this.name}`}</div>;
  }

  setRefPath(refPath) {
    this.refPath = refPath;
  }
  setRefName(refName) {
    this.refName = refName;
  }
  setName(name) {
    this.name = name;
  }
  render() {
    let component;
    const predefine = this.state.ref && this.state.ref.get('predefine') ?
      JSON.parse(this.state.ref.get('predefine')) : {};
    if (this.props.params.refId == 'new' || this.state.ref) {
      component = (<div>
        <form id="refForm" onSubmit={this.onSubmit}>
          <input
            className="hide" type="text" name="predefine"
            value={this.state.ref ? this.state.ref.get('predefine') : undefined} readOnly
          />
          <EditWarningRow />
          <MainComponentBox>
            <Row className={'reference-edit-panel'}>
              <Col xs={12} md={6} lg={6}>
                {this.getLabel()}
                <FormGroup id="name">
                  <ControlLabel style={{ height: 'auto' }}>Name</ControlLabel>
                  <RequiredFormControl
                    component={FormControl}
                    name="name"
                    type="text"
                    disabled={!!predefine.name}
                    defaultValue={this.state.ref ? this.state.ref.get('name') : undefined}
                  />
                </FormGroup>
                <FormGroup id="legalName">
                  <ControlLabel style={{ height: 'auto' }}>Legal name</ControlLabel>
                  <FormControl
                    name="legalName"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('legalName') : undefined}
                  />
                </FormGroup>
                <FormGroup id="yearOfStart">
                  <ControlLabel
                    style={{ height: 'auto' }}
                  >
                   Year of relationships' start
                  </ControlLabel>
                  <FormControl
                    name="yearOfStart"
                    type="number"
                    defaultValue={this.state.ref ?
                      this.state.ref.get('yearOfStart') : new Date().getYear() + 1900}
                  />
                </FormGroup>
                <FormGroup id="addressLine">
                  <ControlLabel style={{ height: 'auto' }}>Address line</ControlLabel>
                  <FormControl
                    name="addressLine"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('addressLine') : undefined}
                  />
                </FormGroup>
                <FormGroup id="postCode">
                  <ControlLabel style={{ height: 'auto' }}>Postal code</ControlLabel>
                  <FormControl
                    name="postCode"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('postCode') : undefined}
                  />
                </FormGroup>
                <FormGroup id="city">
                  <ControlLabel style={{ height: 'auto' }}>City</ControlLabel>
                  <FormControl
                    name="city"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('city') : undefined}
                  />
                </FormGroup>
                <FormGroup id="country">
                  <ControlLabel style={{ height: 'auto' }}>Country</ControlLabel>
                  <FormControl
                    name="country"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('country') : undefined}
                  />
                </FormGroup>
                <FormGroup id="telephone">
                  <ControlLabel style={{ height: 'auto' }}>Telephone</ControlLabel>
                  <FormControl
                    name="telephone"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('telephone') : undefined}
                  />
                </FormGroup>
                <FormGroup id="fax">
                  <ControlLabel style={{ height: 'auto' }}>Fax</ControlLabel>
                  <FormControl
                    name="fax"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('fax') : undefined}
                  />
                </FormGroup>
                <FormGroup id="email">
                  <ControlLabel style={{ height: 'auto' }}>Email</ControlLabel>
                  <FormControl
                    name="email"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('email') : undefined}
                  />
                </FormGroup>
                <FormGroup id="personInCharge">
                  <ControlLabel style={{ height: 'auto' }}>Person in charge</ControlLabel>
                  <FormControl
                    name="personInCharge"
                    type="text"
                    defaultValue={this.state.ref ? this.state.ref.get('personInCharge') : undefined}
                  />
                </FormGroup>
                <Button
                  id="saveButton"
                  type="submit" bsStyle="primary" disabled={this.props.saving}
                >
                  {this.props.params.refId === 'new' ? 'Add' : 'Save'}
                </Button>
                <Button id="cancelButton" bsStyle="gray" onClick={this.onCancel}>Cancel</Button>
                <FormControl
                  name="id" type="id" style={{ display: 'none' }}
                  defaultValue={this.state.ref ? this.state.ref.get('id') : undefined}
                />
              </Col>
            </Row>
          </MainComponentBox>
        </form>
      </div>);
    } else {
      component = <div></div>;
    }
    return component;
  }
}
Edit.propTypes = {
  cancel: React.PropTypes.func,
  refObject: React.PropTypes.object,
  params: React.PropTypes.object,
  updateRef: React.PropTypes.func,
  createRef: React.PropTypes.func,
  saving: React.PropTypes.bool,
};
